import React, { useEffect } from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import useGetDataPaginatedList from "../../../hooks/useGetDataPaginatedList";
import NotificationsService from "../../../services/NotificationsService";
import "./ListWebhooks.css";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Pagination from "../../../components/Pagination/Pagination";

const ListWebhooks = (props) => {
	const { data, columnClicked, maxPage, setColumnClicked, refetchData, isLoading } =
		useGetDataPaginatedList("webhooks", 1, props.filters, {
			collumnTitle: "createdAt",
			orderDirection: "DESC",
			refreshKey: props.refreshKey,
		});

	useEffect(() => {
		refetchData("webhooks", 1, props.filters, columnClicked);
	}, [props.filters, props.refreshKey]);

	return (
		<React.Fragment>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					handleCollumnTitleClick={(collumnIndex) =>
						setColumnClicked(collumnIndex)
					}
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{ collumnLabel: "URL", index: "url", type: "text" },
						{
							collumnLabel: "Habilitado",
							index: "enabled",
							type: "boolean",
						},
					]}
					data={data}
				/>
			</div>
			<div className="card-visibility">
				{data &&
					data.map((webhook, index) => (
						<Card
							key={index}
							image={profileAvatar}
							delete={() => NotificationsService.deleteWebhook(webhook.id)}
							navigateOnDelete={"../consulta-webhooks"}
							navigateOnEdit={"../cadastro-webhooks"}
							data={webhook}
						>
							<p className="card-content-title">{webhook.name}</p>
							<p className="card-content">URL: {webhook.url}</p>
							<p className="card-content">Secret: {webhook.secret}</p>
						</Card>
					))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					refetchData("webhooks", page, props.filters, columnClicked)
				}
			/>
		</React.Fragment>
	);
};

export default ListWebhooks;
